/**
 *
 * DeleteButton
 *
 */

import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Button, Popconfirm, notification } from 'antd';

// utils
import history from 'utils/history';

function DeleteButton({
  buttonText,
  message,
  successMessage,
  loading,
  deleteHandle,
  // default props
  className,
}) {
  const childClassNames = classNames('delete-button-wrapper', className);

  useEffect(() => {
    if (loading) {
      history.push({ pathname: `/сours/` });
      notification.success({ message: successMessage });
    }
  }, [loading]);

  return (
    <>
      <Popconfirm
        placement="top"
        title={message}
        onConfirm={() => deleteHandle()}
        okText="Supprimer"
        cancelText="Annuler"
        overlayClassName="popconfirm-window"
      >
        <Button loading={loading} className={childClassNames}>{buttonText}</Button>
      </Popconfirm>
    </>
  );
}

DeleteButton.defaultProps = {
  message: `Cette action est irréversible, êtes-vous sûr de vouloir supprimer ?`,
  successMessage: `Cours supprimé avec succès!`,
  buttonText: `Supprimer le cours`,
};
DeleteButton.propTypes = {
  loading: PropTypes.bool,
  deleteHandle: PropTypes.func,
};

export default memo(DeleteButton);
